import { GetBy } from '../_app/cuchillo/core/Element';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import BGVideo from '../layout/BGVideo';
import Header from '../layout/Header';
import NoScroll from './NoScroll';
import Default from './Default';

export default class Bio extends Default {
   
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
  }

  beforeShow() {
    ControllerPage.enable_ESC_Mode();
    Header.closeHeader();
    BGVideo.blur = 120;
    BGVideo.grayscale = 1;
    BGVideo.scale = 4;
    super.beforeShow();
  }

  beforeHide() {
    ControllerPage.enable_ESC_Mode(false);
    super.beforeHide();
  }

  afterHide() {
    BGVideo.blur = 0;
    BGVideo.grayscale = 0;
    BGVideo.scale = 1;
    super.afterHide();
  }
}

ControllerPage._addPage("page-bio", Bio)
